import React from 'react';

import { Flex, rem } from '@vimeo/bokeh';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';
import { BokehSkeleton } from '@vimeo/live-core/components/bokeh';
import { range } from '@vimeo/live-core/utils/general/lambda';

import { createInteractionDomName } from '../../../libs/shared/utils/dom/identifying';

/**
 * Component to display progress of chat/history loading.
 */
export function ChatPreloader({
  id = createInteractionDomName('chat-preloader'),
  className = createInteractionDomName('chat-preloader'),
}: IBaseDomElementProps) {
  return (
    <Flex
      id={id}
      className={className}
      flexDirection={'column'}
      alignItems={'center'}
      width={'100%'}
      flexGrow={1}
      overflow={'hidden'}
    >
      <Flex
        id={createInteractionDomName(id, 'history')}
        className={createInteractionDomName(className, 'history')}
        width={'100%'}
        overflow={'hidden'}
        flexDirection={'column'}
        height={'100%'}
        padding={`0 ${rem(16)}`}
      >
        {range(20).map((it) => (
          <BokehSkeleton
            key={it}
            className={createInteractionDomName(className, 'message')}
            marginBottom={rem(16)}
            padding={rem(20)}
            borderRadius={rem(4)}
          />
        ))}
      </Flex>
    </Flex>
  );
}
